import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchConversationBusinesses,
  fetchConversationThread,
  fetchConversationThreads,
  resetState,
  setFilters,
  setPageNumber,
  setRowsPerPage,
  setSelectedThread,
} from "../../store/conversations";

function useConversations() {
  const dispatch = useDispatch();
  const conversations = useSelector((state) => state.conversations || {});
  const {
    businesses = [],
    error = null,
    filters = {},
    messages = [],
    pagination = {},
    selectedThread = null,
    threads = [],
    threadsTotal = 0,
    ui = {},
  } = conversations;

  const getBusinessesAction = useCallback(
    () => dispatch(fetchConversationBusinesses()),
    [dispatch]
  );
  const getThreadsAction = useCallback(
    (params) => dispatch(fetchConversationThreads(params)),
    [dispatch]
  );
  const getThreadAction = useCallback(
    (params) => dispatch(fetchConversationThread(params)),
    [dispatch]
  );
  const setFiltersAction = useCallback(
    (params) => dispatch(setFilters(params)),
    [dispatch]
  );
  const setPageNumberAction = useCallback(
    (params) => dispatch(setPageNumber(params)),
    [dispatch]
  );
  const setRowsPerPageAction = useCallback(
    (params) => dispatch(setRowsPerPage(params)),
    [dispatch]
  );
  const setSelectedThreadAction = useCallback(
    (params) => dispatch(setSelectedThread(params)),
    [dispatch]
  );
  const resetAction = useCallback(() => dispatch(resetState()), [dispatch]);

  return {
    businesses,
    threads,
    threadsTotal,
    selectedThread,
    messages,
    filters,
    pagination,
    ui,
    error,
    getBusinessesAction,
    getThreadsAction,
    getThreadAction,
    setFiltersAction,
    setPageNumberAction,
    setRowsPerPageAction,
    setSelectedThreadAction,
    resetAction,
  };
}

export default useConversations;
